import { ApplicationState } from "./models";

export const basePathSelector = (state: ApplicationState) => {
    const routeName = "book-appointments";
    return state.router.pathname.substring(0, state.router.pathname.indexOf(routeName) + routeName.length);
};

export const appointmentIdSelector = (state: ApplicationState) => {
    return state.router.params.appointmentId;
};
